import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Schedule
 */

export default function ScheduleIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <path
        clipRule="evenodd"
        d="M6 3V1.5C6 1.22386 5.77614 1 5.5 1C5.22386 1 5 1.22386 5 1.5V3H4C2.89543 3 2 3.89543 2 5V6V13C2 14.1046 2.89543 15 4 15H12C13.1046 15 14 14.1046 14 13V6V5C14 3.89543 13.1046 3 12 3H11V1.5C11 1.22386 10.7761 1 10.5 1C10.2239 1 10 1.22386 10 1.5V3H6ZM3 6H13V13C13 13.5523 12.5523 14 12 14H4C3.44772 14 3 13.5523 3 13V6ZM4 7.5C4 7.22386 4.22386 7 4.5 7H5.5C5.77614 7 6 7.22386 6 7.5V8.5C6 8.77614 5.77614 9 5.5 9H4.5C4.22386 9 4 8.77614 4 8.5V7.5ZM7.5 7C7.22386 7 7 7.22386 7 7.5V8.5C7 8.77614 7.22386 9 7.5 9H8.5C8.77614 9 9 8.77614 9 8.5V7.5C9 7.22386 8.77614 7 8.5 7H7.5ZM10 7.5C10 7.22386 10.2239 7 10.5 7H11.5C11.7761 7 12 7.22386 12 7.5V8.5C12 8.77614 11.7761 9 11.5 9H10.5C10.2239 9 10 8.77614 10 8.5V7.5ZM4.5 10C4.22386 10 4 10.2239 4 10.5V11.5C4 11.7761 4.22386 12 4.5 12H5.5C5.77614 12 6 11.7761 6 11.5V10.5C6 10.2239 5.77614 10 5.5 10H4.5ZM7 10.5C7 10.2239 7.22386 10 7.5 10H8.5C8.77614 10 9 10.2239 9 10.5V11.5C9 11.7761 8.77614 12 8.5 12H7.5C7.22386 12 7 11.7761 7 11.5V10.5ZM10.5 10C10.2239 10 10 10.2239 10 10.5V11.5C10 11.7761 10.2239 12 10.5 12H11.5C11.7761 12 12 11.7761 12 11.5V10.5C12 10.2239 11.7761 10 11.5 10H10.5Z"
        fillRule="evenodd"
      />
    </Icon>
  );
}
